import { render, staticRenderFns } from "./ToufangPersonalBoard.vue?vue&type=template&id=14dc69af&scoped=true&"
import script from "./ToufangPersonalBoard.vue?vue&type=script&lang=js&"
export * from "./ToufangPersonalBoard.vue?vue&type=script&lang=js&"
import style0 from "./ToufangPersonalBoard.vue?vue&type=style&index=0&id=14dc69af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dc69af",
  null
  
)

export default component.exports